// eslint-disable-next-line @typescript-eslint/no-explicit-any
let EmbeddedService: any = null;

const headerAlreadyHacked = () => {
  return null !== document.querySelector('embeddedservice-chat-header > button');
};
const destroyLiveChat = () => {
  if (EmbeddedService) {
    EmbeddedService.liveAgentAPI.endChat();
  } else {
    console.error("Salesforce API not present, can't close chat. Has Salesforce API changed?");
  }
};
const minimizeLiveChat = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Sidebar: any = Object.values(EmbeddedService.sidebarInstanceMap)[0];
  if (Sidebar && Sidebar.minimize) {
    Sidebar.minimize();
  } else {
    console.error("Salesforce API not present, can't minimize chat. Has Salesforce API changed?");
  }
};
export const salesforceChatHack = {
  helpButtonHandler: () => {},
  maximizeHandler: () => {
    //@ts-expect-error
    EmbeddedService = window.embedded_svc;
    const chatHeader = document.querySelector('embeddedservice-chat-header');
    if (chatHeader && !headerAlreadyHacked()) {
      const minButton = document.createElement('button');
      minButton.onclick = minimizeLiveChat;
      minButton.innerHTML = '&DownArrowBar;';
      minButton.className = 'minimize';
      minButton.title = 'Minimize Chat';
      minButton.setAttribute('aria-label', 'Minimize Chat');
      chatHeader?.appendChild(minButton);

      const closeButton = document.createElement('button');
      closeButton.onclick = destroyLiveChat;
      closeButton.innerHTML = '&times;';
      closeButton.className = 'closeSalesforceChatButton';
      closeButton.title = 'Close Chat';
      closeButton.setAttribute('aria-label', 'Close Chat');
      chatHeader?.appendChild(closeButton);

      chatHeader?.classList.add('hacked');
    }
  },
};
